module.exports = __webpack_public_path__ + "static/media/logo.f560e2de.png";